<template lang="html">
  <v-container :fluid="true" grid-list-lg class="pa-3 bgs-container">
    <v-layout v-bind="binding">

      <!-- Filters -->
      <v-flex sm12 md12 lg3 xl2>
        <v-card class="filters-container">
          <v-system-bar color="accent" dark window @click.native="isFiltersVisible = !isFiltersVisible" style="cursor: pointer;">
            <v-icon center>filter_list</v-icon>
            <v-toolbar-title class="ml-0">Фильтры</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small icon>
              <v-icon class="mx-0">{{ isFiltersVisible ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
            </v-btn>
          </v-system-bar>
          <v-slide-y-transition>
            <v-card-text v-show="isFiltersVisible" class="pa-0">
              <template v-if="filterLoadingError">
                <v-alert :value="true" type="error" outline>
                  Произошла ошибка при загрузке фильтров
                </v-alert>
                <v-btn small @click="getFiltersData()" color="secondary">
                  <v-icon left>cached</v-icon>
                  Повторить
                </v-btn>
              </template>
              <FilterContainer v-else
                :loading="loadingFilters"
                :filters="filters"
                v-on:filtersChange="onFiltersChange"
              />
            </v-card-text>
          </v-slide-y-transition>
        </v-card>
      </v-flex>

      <!-- Summary table -->
      <v-flex sm12 md12 lg9 xl10>
        <v-card>
          <v-system-bar color="accent" dark window>
            <v-icon center>list</v-icon>
            <v-toolbar-title class="ml-0">Свод по процессам</v-toolbar-title>
          </v-system-bar>
          <v-card-text>
            <template v-if="dataLoadingError">
              <v-alert :value="true" type="error" outline>
                Произошла ошибка при загрузке данных
              </v-alert>
              <v-btn small @click="getListData()" color="secondary" class="ml-0">
                <v-icon left>cached</v-icon>
                Повторить
              </v-btn>
            </template>
            <v-data-table v-else
                          v-bind:headers="headers"
                          v-bind:items="items"
                          v-bind:search="search"
                          v-bind:pagination.sync="pagination"
                          :total-items="totalItems"
                          :loading="loading"
                          class="summary-data"
                          id="process-list-table"
                          item-key="id"
                          rows-per-page-text="Элементов на страницу"
                          v-bind:rows-per-page-items="rowsPerPageDefault"
                          no-data-text="Нет доступных данных"
                          no-results-text="Не найдено подходящих значений"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="text-xs-left" @click="onDataClick(props.item)">{{ props.item.title }}</td>
                  <td class="text-xs-center" @click="onDataClick(props.item)">{{ props.item.total }}</td>
                  <td class="text-xs-center" @click="onDataClick(props.item, 'running')">{{ props.item.running }}</td>
                  <td class="text-xs-center" @click="onDataClick(props.item, 'hold')">{{ props.item.hold }}</td>
                  <td class="text-xs-center" @click="onDataClick(props.item, 'expired')">{{ props.item.expired }}</td>
                  <td class="text-xs-center" @click="onDataClick(props.item, 'finished')">{{ props.item.finished }}</td>
                  <td class="text-xs-center" @click="onDataClick(props.item, 'pending')">{{ props.item.pending }}</td>
                  <td class="text-xs-center" @click="onDataClick(props.item, 'pool')">{{ props.item.pool }}</td>
                  <td class="text-xs-center" @click="onDataClick(props.item, 'canceled')">{{ props.item.canceled }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from 'lodash'
import { mapGetters } from 'vuex'

import apiRoutes from '../api/routes'
import httpClient from '@/api/http-client'
const http = httpClient.http

// Mixins.
import commons from '../../mixins/commons'
import monitor from '../../mixins/monitor'
import filtered_list_routing from '../../mixins/filtered_list_routing'

// Components.
import FilterContainer from '../../components/FilterContainer'

const consoleDebug = Boolean(process.env.NODE_ENV == 'development')

export default {
  mixins: [
    commons,
    monitor,
    filtered_list_routing
  ],

  components: {
    FilterContainer
  },

  computed: {
    ...mapGetters('app/layout', ['getRouteData']),
    binding () {
      const binding = {}

      // if (this.$vuetify.breakpoint.smAndDown) 
      if (this.$vuetify.breakpoint.mdAndDown)
        binding.column = true
      else 
        binding.row = true

      return binding
    }
  },

  data () {
    return {
      headers: [
        { text: 'Название процесса', align: 'left', sortable: false, value: 'title' },
        { text: 'Всего', align: 'center', sortable: false, value: 'total' },
        { text: 'На исполнении', align: 'center', sortable: false, value: 'running' },
        { text: 'Заморожено', align: 'center', sortable: false, value: 'hold' },
        { text: 'Просрочено', align: 'center', sortable: false, value: 'expired' },
        { text: 'Завершено', align: 'center', sortable: false, value: 'finished' },
        { text: 'В ожидании', align: 'center', sortable: false, value: 'pending' },
        { text: 'В пуле', align: 'center', sortable: false, value: 'pool' },
        { text: 'Отменено', align: 'center', sortable: false, value: 'canceled' },
      ],

      isFiltersVisible: true,
      dataLoadingError: false,
      filterLoadingError: false
    }
  },

  methods: {
    getListData: function () {
      this.loading = true
      this.dataLoadingError = false
      this.items = []
      this.totalItems = 0


      let params = {
        page_num: this.pagination.page,
        page_size: this.pagination.rowsPerPage,
        sort_by: this.pagination.sortBy,
        descending: this.pagination.descending,
        filters: {}
      }

      // If there are some active (selected) filters:
      for (var filter in this.inputFilters) {
        if( this.inputFilters.hasOwnProperty( filter ) ) {
          if (Array.isArray(this.inputFilters[filter]) && this.inputFilters[filter].length) {
            params.filters[filter] = []

            this.inputFilters[filter].forEach( element => {
              params.filters[filter].push( element )
            } )
          }
        }
      }

      let apiPath = apiRoutes.monitor.summary
      http.get( apiPath + '?' + this.serializeObject( params ) ).then(response => {
        if (response.status == 200 && response.data) {
          this.totalItems = response.data.total_count

          if ( response.data.data && Array.isArray( response.data.data ) ) {
            let items = []

            response.data.data.forEach(element => {
              let item = {
                id: element.entity.id,
                title: element.entity.name,
                total: 0,
                running: 0,
                hold: 0,
                expired: 0,
                finished: 0,
                pending: 0,
                pool: 0,
                canceled: 0,
              }

              if ( element.summary ) {
                element.summary.forEach(summaryItem => {
                  // TODO: optimize code, like:
                  // item[summaryItem.code] = summaryItem.value
                  // ...
                  switch (summaryItem.code) {
                    case "total":
                      item.total = summaryItem.value
                      break;
                    case "running":
                      item.running = summaryItem.value
                      break;
                    case "hold":
                      item.hold = summaryItem.value
                      break;
                    case "finished":
                      item.finished = summaryItem.value
                      break;
                    case "pending":
                      item.pending = summaryItem.value
                      break;
                    case "pool":
                      item.pool = summaryItem.value
                      break;
                    case "expired":
                      item.expired = summaryItem.value
                      break;
                    case "canceled":
                      item.canceled = summaryItem.value
                      break;
                    default:
                  }
                })
              }

              items.push( item )
            })

            this.items = items
          } else {
            this.dataLoadingError = true
            this.$dmsErrorNoty('Произошла ошибка при загрузке данных')
          }
        } else {
          this.dataLoadingError = true
          this.$dmsErrorNoty('Произошла ошибка при загрузке данных')
        }
      }).catch(error => {
        console.warn(error)
        this.dataLoadingError = true
        this.$dmsErrorNoty('Произошла ошибка при загрузке данных')
      }).finally(() => {
        this.loading = false
      })
    },

    getFiltersData: function () {
      this.loadingFilters = true
      this.filterLoadingError = false
      this.filters = []

      // Get all filters
      // let apiPath = apiRoutes.filter.index
      // - OR:
      // Get only one - 'contractor' - filter
      let apiPath = apiRoutes.filter.show.replace( '{filter_code}', 'contractor' )
      http.get( apiPath ).then(response => {
        if (response.status == 200 && response.data) {
          let filters = []

          if (response.data.code === 'contractor') {
            filters.push(response.data)
          }

          this.applyInputFilters( filters )
          this.filters = filters
        } else {
          this.$dmsErrorNoty('Произошла ошибка при загрузке фильтров')
          this.filterLoadingError = true
        }
      }).catch(error => {
        console.warn(error)
        this.$dmsErrorNoty('Произошла ошибка при загрузке фильтров')
        this.filterLoadingError = true
      }).finally(() => {
        this.loadingFilters = false
      })
    },

    getSummaryDataWithDelay: debounce(
      function() {
        this.getSummaryData()
      }, 2000
    ),

    onDataClick: function (item, status = '') {
      let queryParams = {}

      this.addFiltersParams( queryParams )

      if (status) {
        queryParams.filter_status = status
      }

      if (item.id) {
        queryParams.filter_process = item.id
      }

      let newRoute = this.getRouteData({
        name: 'bpm.super-monitor.manage',
        query: queryParams
      })

      // Go to ManageList interface.
      this.$router.push(newRoute)
    }
  }
}
</script>

<style scoped lang="scss">
#process-list-table td, #process-list-table th {
  padding: 3px 5px;
  height: auto;
}

.summary-data {
  tbody > tr > td {
    cursor: pointer;
    transition: background .3s cubic-bezier(.25,.8,.5,1);
    will-change: background;

    &:hover {
      background: #ddd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/bpm/superMonitor/pages/Summary.vue